export function clamp(value: number, min = 0, max = 1): number {
  return Math.min(max, Math.max(min, value));
}

export function progress(time: number, start: number, end: number): number {
  return clamp((time - start) / (end - start));
}

export function easeOut(x: number): number {
  return 1 - Math.pow(1 - x, 3);
}

export function easeInOut(x: number): number {
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}

/** Eased 0→1 reveal starting at `start` lasting `duration` seconds. */
export function reveal(time: number, start: number, duration = 0.6): number {
  return easeOut(progress(time, start, start + duration));
}

/** Scale that slams from 1+amount down to 1 right after a cut. */
export function punch(time: number, at: number, amount = 0.06, duration = 0.35): number {
  if (time < at) return 1 + amount;
  return 1 + amount * (1 - easeOut(progress(time, at, at + duration)));
}

export function lerp(a: number, b: number, p: number): number {
  return a + (b - a) * p;
}

export function formatTime(seconds: number): string {
  const s = Math.floor(seconds);
  return `00:${s.toString().padStart(2, '0')}`;
}
